export enum Events {
	ONLINE = 'online',
	OFFLINE = 'offline'
}
